import React, { useEffect, useState } from 'react';

import AdviceSection from '../common/AdviceSection';
import EUCountryCard from '../common/cards/EUCountryCard';
import IndividualCountrySelect from '../common/select-filters/IndividualCountrySelect';
import SelectDataset from '../common/SelectDataset';
import CountryCards from '../common/cards/CountryCards';
import Pagination from '../common/pagination/Pagination';
import Methodology from '../common/Methodology';

import { getHealthPerceptionCountries, getHealthPerceptionData } from '../../api';

const HealthPerception = props => {
    
    const pageSize = 15;

    const [euData, setEUData] = useState(null);
    const [countriesData, setCountriesData] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [pageOfItems, setPageOfItems] = useState([]);
    const [filters, setFilters] = useState({
        countries: [],
        datasetEurofound: '',
        datasetEurostat: ''
    });

    useEffect(() => {
        // Update the title of the page
        document.title = props.literals.L22011 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

        getHealthPerceptionCountries()
        .then((res) => {
            setCountryList(res.resultset);
        });

        loadCountriesData();
    }, [])

    useEffect(() => {
        loadCountriesData();
    }, [filters])

    const loadCountriesData = () => {
        getHealthPerceptionData(filters)
        .then((res) => {
            let euDataValues = res.resultset.find(country => country.countryCode === 'EU27_2020');
            if (euDataValues == undefined)
            {
                euDataValues = res.resultset.find(country => country.countryCode === 'EU28');
            }
            setEUData( euDataValues );

            setCountriesData( res.resultset.filter(country => country.countryCode != 'EU27_2020' && country.countryCode != 'EU28') );
        })
    }

    //when country is selected
    const onSelectCountryTag = (countryCode) => {
        return () => {
            const countryIndex = filters.countries.findIndex((country) => country.code == countryCode);
            const newArray = filters.countries;
            newArray.splice(countryIndex, 1);
            setFilters( {...filters, countries: newArray } );
        }
    }

    // Handles change of page when clicked on the next or prev
    const onChangePage = (page) => {
        setPageOfItems(page);
    }

    const handleCallbackCountry = (countryCallback) => {
        const countryFilter = filters.countries;
        const countryCode = filters.countries.find((country) => country.code == countryCallback.code)
        if (countryCallback.code != countryCode?.code) {
            setFilters( {...filters, countries: [...countryFilter, countryCallback ] } );
        } else {
            const index = filters.countries.findIndex((country) => country.code == countryCallback.code);
            const newCountryFilters = filters.countries;
            newCountryFilters.splice(index, 1);
            setFilters( {...filters, countries: newCountryFilters } );
        }
    }

    const handleDatasetEurofoundChange = (datasetEurofound) =>
    {
        setFilters( {...filters, datasetEurofound } );
    }

    const handleDatasetEurostatChange = (datasetEurostat) =>
    {
        setFilters( { ...filters, datasetEurostat } );
    }
    
    return(
        <div className="health-perception-workers">
            <AdviceSection literals={ props.literals } section={["accidents-diseases-well-being","health-perception-of-workers"]} methodologyData={{section: 'accidents-diseases-well-being', subsection: 'Health perception of the workers', indicator: 57}} />

            <EUCountryCard literals={ props.literals } euData={ euData } page={'healthPerception'}/>

            <section className="container">
                {/*  FILTERS */}
                <form className="row block--filter--wrapper">
                    {/*  COUNTRY FILTER */}
                    <IndividualCountrySelect literals={ props.literals } selectCountries={ countryList } 
                        onClickCountry={ handleCallbackCountry } selectedFilters={ filters } />

                    {/* DATASET FILTER */}
                    <SelectDataset chart= { '20026' } indicator={ ['58', '60', '61', '65'] } handleDatasetChange={ handleDatasetEurofoundChange } />
                    <SelectDataset chart= { '20026' } indicator={ ['59'] } handleDatasetChange={ handleDatasetEurostatChange } />
                </form>
                <div className="container">
                    <div className="selected--tags-wrapper">
                        {filters && (
                            <div>
                                {filters.countries.map((country) => (
                                    <span key={country.code} className="selected-tag" onClick={ onSelectCountryTag(country.code) }>{ country.code == 'EU28' || country.code == 'EU27_2020' ? '' : `(${country.code})` } { country.name }</span>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="card--grid xxs-w1 xs-w2 w3 center-text">
                        {
                            pageOfItems.map((countryData) => (
                                <div className="card--block--chart" key={ countryData.countryCode }>
                                    <CountryCards literals={ props.literals } countryData={ countryData } page={ 'healthPerception' }/>
                                </div>
                            ))
                        }
                    </div>

                    <Pagination items={ countriesData } onChangePage={ onChangePage } pageSize={ pageSize } />
                    <div className='text-center'>{ props.literals.L20642 }</div>
                </div>
            </section>

            <Methodology literals={ props.literals } section={ 'Health perception of the workers' } />
        </div>
    )
}
HealthPerception.displayName = 'HealthPerception';
export default HealthPerception;